package org.catharsis.spendtel.core.api

import org.catharsis.spendtel.feature.data.EventName
import org.catharsis.spendtel.feature.data.ScreenName

interface AnalyticsApi {
    fun logClickEvent(eventName: EventName, extras: Map<String, Any>? = null)
    fun logScreenViewed(screenName: ScreenName)
}